export function getTimestampMs(value) {
  if (!value) return 0;
  if (typeof value.toMillis === 'function') return value.toMillis();
  if (typeof value.seconds === 'number') {
    const millis = value.seconds * 1000;
    const nanos = typeof value.nanoseconds === 'number' ? Math.floor(value.nanoseconds / 1e6) : 0;
    return millis + nanos;
  }
  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : 0;
}

const ROOM_WORKFLOW_TONES = {
  pending_summary: {
    badgeClass: 'bg-blue-950/50 text-blue-300 border border-blue-700/50',
    panelClass: 'border-blue-500/30 bg-blue-950/20 text-blue-100',
  },
  updated_after_summary: {
    badgeClass: 'bg-amber-950/50 text-amber-200 border border-amber-700/50',
    panelClass: 'border-amber-500/30 bg-amber-950/20 text-amber-100',
  },
  assetized: {
    badgeClass: 'bg-emerald-950/50 text-emerald-300 border border-emerald-700/50',
    panelClass: 'border-emerald-500/30 bg-emerald-950/20 text-emerald-100',
  },
  summarized: {
    badgeClass: 'bg-purple-950/50 text-purple-300 border border-purple-700/50',
    panelClass: 'border-purple-500/30 bg-purple-950/20 text-purple-100',
  },
};

export function getRoomWorkflowTone(workflowKey) {
  return ROOM_WORKFLOW_TONES[workflowKey] || ROOM_WORKFLOW_TONES.summarized;
}

export function getRoomWorkflowState(room, summaryNote = null) {
  const hasSummary = Boolean(room?.summaryNoteId);
  const summaryUpdatedMs = getTimestampMs(summaryNote?.updatedAt || summaryNote?.createdAt);
  const lastMessageMs = getTimestampMs(room?.lastMessageAt);
  const hasUpdatesAfterSummary = hasSummary && summaryUpdatedMs > 0 && lastMessageMs > summaryUpdatedMs;

  if (!hasSummary) {
    return {
      key: 'pending_summary',
      shortLabel: 'Noteまとめ未',
      label: 'Raw保存済み / Noteまとめ未',
      description: 'Rawは保存済みです。区切りがついたら「考えを要約する」でNoteとして残せます。',
      timingHint: '迷ったら、話題が一段落した時・後で読み返したい時にまとめればOKです。',
      ctaLabel: '考えを要約する',
      action: 'memoize',
      requiresMemo: true,
    };
  }

  if (hasUpdatesAfterSummary) {
    return {
      key: 'updated_after_summary',
      shortLabel: '更新あり',
      label: 'Noteまとめ後に更新あり',
      description: '最後のNoteまとめ以降にRawが増えています。必要になったら要約し直して最新化できます。',
      timingHint: '追加メモが増えて読み返しづらくなった時だけ、更新分をまとめ直せば十分です。',
      ctaLabel: '更新分をNoteに反映する',
      action: 'memoize',
      requiresMemo: true,
    };
  }

  if (room?.status === 'assetized') {
    return {
      key: 'assetized',
      shortLabel: 'Asset化あり',
      label: 'Noteまとめ済み / Asset化あり',
      description: 'このRoomの内容はNoteとして残っており、一部はAsset化まで進めています。',
      timingHint: 'HintやAssetは全部埋めなくてOKです。使いたいものだけ育てれば十分です。',
      ctaLabel: 'Noteを開く',
      action: 'open_note',
      requiresMemo: false,
    };
  }

  return {
    key: 'summarized',
    shortLabel: 'Noteあり',
    label: 'Noteまとめ済み',
    description: 'このRoomはNoteとして残せています。次はSyncでHintを確認するか、このまま保管してOKです。',
    timingHint: 'Hintは全部すぐ処理しなくてOKです。必要になった時だけAsset化すれば十分です。',
    ctaLabel: 'Noteを開く',
    action: 'open_note',
    requiresMemo: false,
  };
}

export function isRoomPendingSummary(room, summaryNote = null) {
  return getRoomWorkflowState(room, summaryNote).requiresMemo;
}
